import React, {useEffect, useState} from "react";
import {Alert, CircularProgress} from "@mui/material";
import {ApiUrl, PortalUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import {StyledContainer} from "../utils/customStyles";
import {Link, useParams} from "react-router-dom";
import LastPublishChartsWidget from "../Charts/LastPublishChartsWidget";
import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import makeStyles from "@mui/styles/makeStyles";
import {formatDateString} from "../utils/cert-helper";
import clsx from "clsx";
import Paper from "@mui/material/Paper";
import {ReportMenu} from "./PublishedAsList";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PublishedTabPanel from "./PublishedTabPanel";
import Box from "@mui/material/Box";


const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    minHeight: {
        minHeight: 120,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    link: {
        color: 'white',
    },
    backButton: {marginRight: 20, marginBottom: 10, marginLeft: -30},
    actionButtons: {float: 'right', marginRight: 10}
}));

export default function SinglePublication() {
    const classes = useStyles();
    const props = useParams();
    console.log('SinglePublication ', useParams());
    const publishId = props.id;
    console.log('publishId', publishId);
    // const id = props.match && props.match.params && props.match.params.id || props.id || 0;
    const [tableListLoading, setTableListLoading] = useState(false);
    const [refresh, setRefresh] = useState(new Date().getTime());
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const fixedHeightMediumPaper = clsx(classes.paper, classes.fixedMediumLarge);
    const fixedHeightLargePaper = clsx(classes.paper, classes.fixedHeightLarge);
    const [data, setData] = useState( null);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg:'', msgLv: ''});

    // console.log('last published contribution', props);

    useEffect(() => {
        fetchPage(publishId);
    }, [ publishId, refresh])


    const fetchPage = async (publishId) => {
        setTableListLoading(true);
        const url =ApiUrl.Published.getPublication.getPath(publishId, true, true);
        // const url =ApiUrl.Published.getPublication.getPath("last", true, true);
        console.log("GET Publication details from: " + url);
        try {
            const res = await fetch(url)
            const data = await handleHttpResponse(res);
            setData(data);
        } catch (err) {
            console.error("failed to get contribution page: " + err)
            setSnackbarMsg({open: true, msg: 'Failed to Get Contribution Page', msgLv: 'error'});
        } finally {
            setTableListLoading(false);
        }
    }

    return (
        <StyledContainer maxWidth='xl'>
            <h3 className='title'>
                {/*<div><Button value='text' className={classes.backButton} color='primary' target='_self' href={PortalUrl.Published.Home.getPath()}> <ArrowBackIosIcon /> Publications </Button></div>*/}
                <div><Button value='text' className={classes.backButton} color='primary' component={Link} to={PortalUrl.Published.Home.getPath()}> <ArrowBackIosIcon /> Publications </Button></div>
                Publication {data && data.publish && formatDateString(data.publish.publishedTs)}

                <Box sx={{ float: 'right', display: 'flex', gap: '10px', justifyContent: 'center'}}>
                    {data && data.publish && data.publish.binaryCount > 0 &&
                        <div> <Button component={Link} to={PortalUrl.Published.HocReport.getPath(data.publish.id)}> View {data.publish.binaryCount} AdHoc Report{`${data.publish.binaryCount > 1 ? 's': ''}`} </Button> </div> }

                    <ReportMenu publicationId={publishId} />
                    {/*<Button href={ApiUrl.Published.getV1Report.getPath(publishId)} target='_blank' startIcon={<FileDownloadIcon/>} >Directory v1</Button>*/}
                    <Button href={ApiUrl.Published.getV2Report.getPath(publishId)} target='_blank' startIcon={<FileDownloadIcon/>} >Directory V3.0</Button>
                </Box>
                {/*<Button className={classes.actionButtons} size="small" href={ApiUrl.Published.getDetailedReport.getPath(publishId)} target='_blank' startIcon={<FileDownloadIcon/>} > Detailed Report</Button>*/}
                {/*<Button className={classes.actionButtons} size="small" href={ApiUrl.Published.getSummaryByFieldReport.getPath(publishId)} target='_blank' startIcon={<FileDownloadIcon/>} > Summary (Field) Report</Button>*/}
                {/*<Button className={classes.actionButtons} size="small" href={ApiUrl.Published.getSummaryByRuleReport.getPath(publishId)} target='_blank' startIcon={<FileDownloadIcon/>} > Summary (Rule) Report</Button>*/}
                {/*<Button className={classes.actionButtons} size="small" href={ApiUrl.Published.getSummaryReport.getPath(publishId)} target='_blank' startIcon={<FileDownloadIcon/>} > Summary Report</Button>*/}
            </h3>

            {tableListLoading && <Alert severity='info' icon={<CircularProgress />} style={{lineHeight: '37px'}} > Loading recent contributions... </Alert> }
            <Paper className={fixedHeightMediumPaper}>
                {!tableListLoading && data && data.publish &&
                    <LastPublishChartsWidget publish={data.publish} hispsPieData={data.hispRecordsPie} errorBarData={data.errorBar}/>}
            </Paper>
            {/*{!tableListLoading && data && data.publish && <ShowPublishWidget publish={data.publish} hispsPieData={data.hispRecordsPie} errorBarData={data.errorBar} /> }*/}
            {!tableListLoading && data?.contributions &&
                <PublishedTabPanel contributions={data.contributions}/>
            }
            {/*{!tableListLoading && data && data.contributions && <div className="contribution-list-wrap">*/}
            {/*     <ContributionsAsList contributions={data.contributions} setSnackbarOpen={(s) => setSnackbarMsg(s)} minimum={false}/>*/}
            {/*</div>*/}
            {/*}*/}
        </StyledContainer>
    )
}
